import { render, staticRenderFns } from "./ImgFallback2.vue?vue&type=template&id=f46ce696&"
import script from "./ImgFallback2.vue?vue&type=script&lang=js&"
export * from "./ImgFallback2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f46ce696')) {
      api.createRecord('f46ce696', component.options)
    } else {
      api.reload('f46ce696', component.options)
    }
    module.hot.accept("./ImgFallback2.vue?vue&type=template&id=f46ce696&", function () {
      api.rerender('f46ce696', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2FdOju7M4rfC8/JS/comp/ImgFallback2.vue"
export default component.exports